import { ReadOnlyMap } from '@web-platform/shared-universal-utils-frontend/src/helpers/ReadOnlyMap';
import compact from 'lodash/compact';

import { translate } from '../translate';

type IPassengerTypeMap = Array<[number, string]>;

const adultsPair: IPassengerTypeMap = [
  [1, translate('ktxt_1Adult')],
  [2, translate('ktxt_2Adults')],
  [3, translate('ktxt_3Adults')],
  [4, translate('ktxt_4Adults')],
  [5, translate('ktxt_5Adults')],
  [6, translate('ktxt_6Adults')],
  [7, translate('ktxt_7Adults')],
  [8, translate('ktxt_8Adults')],
];

const childrenPair: IPassengerTypeMap = [
  [1, translate('ktxt_1Child')],
  [2, translate('ktxt_2Children')],
  [3, translate('ktxt_3Children')],
  [4, translate('ktxt_4Children')],
  [5, translate('ktxt_5Children')],
  [6, translate('ktxt_6Children')],
  [7, translate('ktxt_7Children')],
  [8, translate('ktxt_8Children')],
];

const infantsPair: IPassengerTypeMap = [
  [1, translate('ktxt_1Infant')],
  [2, translate('ktxt_2Infants')],
  [3, translate('ktxt_3Infants')],
  [4, translate('ktxt_4Infants')],
  [5, translate('ktxt_5Infants')],
  [6, translate('ktxt_6Infants')],
  [7, translate('ktxt_7Infants')],
  [8, translate('ktxt_8Infants')],
];

const adultsMap = ReadOnlyMap(adultsPair);
const childrenMap = ReadOnlyMap(childrenPair);
const infantsMap = ReadOnlyMap(infantsPair);

export const getInfantAndChildCount = (childAges: number[]) => ({
  childCount: childAges.filter((age) => age > 1).length,
  infantCount: childAges.filter((age) => age <= 1).length,
});

export const getAdultsDisplayText = (adults: number) => adultsMap.getOrDefault(adults, '');
export const getChildrenDisplayText = (children: number) => childrenMap.getOrDefault(children, '');
export const getInfantsDisplayText = (infants: number) => infantsMap.getOrDefault(infants, '');

export const getPassengerDisplayText = (adults: number, children: number, infants: number) =>
  compact([
    getAdultsDisplayText(adults),
    getChildrenDisplayText(children),
    getInfantsDisplayText(infants),
  ]).join(', ');
